module.exports = __webpack_public_path__ + "h5/img/new_people.e4c8569e.png";